import { Paper } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import messages from '../../intl/messages';
import { getCurrentExam } from '../../store/model/selectors';

// Device fingerprint hash; null if no desktop app / old version sent one.
const DeviceFingerprint = () => {
	const intl = useIntl();
	const exam = useSelector(getCurrentExam);

	if (!exam) return null;

	const fingerprintHash = exam.fingerprintHash ?? null;

	return (
		<Paper elevation={3} style={{ padding: '20px' }}>
			<FormattedMessage {...messages.deviceFingerprint} />
			{': '}
			{fingerprintHash ? (
				<span style={{ fontFamily: 'monospace', wordBreak: 'break-all' }}>{fingerprintHash}</span>
			) : (
				<span style={{ color: 'gray' }} title={intl.formatMessage(messages.deviceFingerprintUnavailableHint)}>
					<FormattedMessage {...messages.deviceFingerprintUnavailable} />
				</span>
			)}
		</Paper>
	);
};

export default DeviceFingerprint;
